// hooks
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSaveDeclarationType } from './DeclarationTypeForm.hooks';

// utils
import schema from '../../DeclarationType.schema';
import { yupResolver } from '@hookform/resolvers/yup';

// components
import { LoadingButton } from '@mui/lab';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { BaseDeclarationTypeSection } from '../BaseDeclarationTypeSection/BaseDeclarationTypeSection';
import { DeclarationTypeFormProps } from './DeclarationTypeForm.types';
import { DeclarationTypeResponse } from 'generated/index';

type DeclarationTypeFormData = Partial<DeclarationTypeResponse>;

export const DeclarationTypeForm = ({
  rowData,
  handleClose
}: DeclarationTypeFormProps) => {
  const { t } = useTranslation('common');

  const methods = useForm<DeclarationTypeFormData>({
    defaultValues: rowData || {
      name: '',
      isDefault: false,
      validFrom: undefined,
      validTo: undefined
    },
    resolver: yupResolver(schema)
  });

  const { mutate, isLoading } = useSaveDeclarationType({
    onSuccess: handleClose
  });

  const { control, handleSubmit } = methods;

  const onSubmit = (data: DeclarationTypeFormData) => {
    mutate(data as DeclarationTypeResponse);
  };

  return (
    <MultiStepForm onSubmit={handleSubmit(onSubmit)} methods={methods}>
      <BaseDeclarationTypeSection control={control} />
      <MultiStepForm.Actions>
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="primary"
          fullWidth
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};
